const onlyNumbersRegexp = /^[0-9]+$/;

const onlyUkrString = /^[ а-щА-ЩЬьЮюЯяЇїІіЄєҐґ'`]+$/;

export { onlyNumbersRegexp, onlyUkrString };
